import React from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import PageTitle from '../PageTitle';
import $ from 'jquery';

import { doRequest } from '../../helper';
import { constants } from '../../Bootstrap';


import AWS from 'aws-sdk';

export default class AddPledge extends React.Component {
    constructor() {
        super();
        var now = Date.now();
        this.state = {
            frame: <img />,
            canvasKey: "NMBirthday/nm_" + now + '.jpg',
            bucketUrl: "https://s3.ap-south-1.amazonaws.com/js-sdk-bucket/",
            canvasThumbKey: "NMBirthday/nm_thumb" + now + '.jpg',

        }
        this.savePledge = this.savePledge.bind(this);
        AWS.config.region = 'ap-south-1'; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: 'ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f',
        });
        this.bucketname = 'js-sdk-bucket';
        this.bucket = new AWS.S3({
            params: {
                Bucket: this.bucketname
            }
        });
        this.cropImage = this.cropImage.bind(this);

        this.readURL = this.readURL.bind(this);
        this._crop = this._crop.bind(this);
        this.dataURLtoFile = this.dataURLtoFile.bind(this)

    }
    uploadToS3(file, type, bucket, callback) {


        var objKey = null;
        if (type == "canvas") {
            objKey = this.state.canvasKey;
        } if (type == "thumb") {
            objKey = this.state.canvasThumbKey;
        }
        var params = {
            Key: objKey,
            ContentType: file.type,
            Body: file,
            ACL: 'public-read'
        };
        if (!callback) {
            callback = (err, data) => {

            }
        }
        bucket.putObject(params, callback);

    }

    readURL(input) {
        var ref = this;
        //reset
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                var img = <img src={e.target.result} style={{ "width": "100%" }} />;
                ref.setState({ "video": null, "imgsrc": e.target.result, "frame": img, "image": input.files[0] });
            }

            reader.readAsDataURL(input.files[0]);
        }
    }



    savePledge() {
        if (this.title.value == "" && this.description.value == "" && this.color.value == "") {
            alert("please fill all details!")
            return true;
        }
        else {
            if (this.title.value == "") {
                alert("Please add Title!")
                return true;
            }
            if (this.description.value == "") {
                alert("Please add Description!")
                return true;
            }
            if (this.color.value == "") {
                alert("Please add Color!")
                return true;
            }
            var ref = this;
            var title = this.title.value;
            var data = {};
            if ($.trim(title) != "" && this.state.image) {

                ref.uploadToS3(this.state.image, 'canvas', ref.bucket, function () {
                    alert("Image NM Birthday updated");
                });
                console.log(this.state.image)
                data['image_path'] = this.state.bucketUrl + this.state.canvasKey;

            }
            else {
                return false;
            }
            if (this.state.image1) {
                ref.uploadToS3(this.state.image1, 'thumb', ref.bucket, function () {
                    alert("Image NM Thumb Birthday updated");
                });
                console.log(this.state.image1)
                data['thumb_path'] = this.state.bucketUrl + this.state.canvasThumbKey;
            }
            data['title'] = title;

            var proceed = true;
            if ($.trim(this.description.value) == "") {
                proceed = window.confirm("Do you want to save video without description ?");
            } else {
                data['description'] = this.description.value;
            }

            data["type"] = this.category.value;
            data["language"] = this.language.value;
            //  data["language"] = this.language
            //   data["language"]= $("#lang option:selected").text();
            // if(this.language.value=="english"){
            //     data["language"] = "en";
            // }
            // else if(this.language.value=="hindi"){
            //     data["language"] = "hi";
            // }


            data["textcolour"] = this.color.value;
            console.log(data);

            if (proceed) {

                $(".loader").show();
                var payload = {
                    "action": "save-pledge",
                    "module": "bday",
                    "model": "pledge",
                    "data": data
                }
                console.log(payload)
                //return true;
                var request = doRequest('cms-operations', payload, true);

                request.addEventListener("load", function () {

                    $(".loader").hide();
                    var response = this.responseText;
                    try {
                        response = JSON.parse(response);
                        if (response._resultflag && response._resultflag == 1) {
                            var now = Date.now();
                            alert('NMBirthday Module Saved')
                            ref.title.value = '';
                            ref.description.value = '';
                            //  ref.url.value = '';
                            ref.setState({ canvasKey: "NMBirthday/nm_" + now + '.jpg' })
                            window.location.href="/NMBirthday/add-pledge"

                        }
                    } catch (ex) {
                        alert('Server Error')

                    }

                });

            }
        }
    }
    _crop() {

        // image in dataUrl
        console.log(this.refs.cropper.getCroppedCanvas().toDataURL());
    }
    cropImage() {
        if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
            return;
        }
        this.setState({
            cropResult: this.cropper.getCroppedCanvas().toDataURL(),
        });
        console.log(this.cropper.getCroppedCanvas().toDataURL())
        var nm = this.dataURLtoFile(this.cropper.getCroppedCanvas().toDataURL(), 'test.jpg')
        console.log(nm)
        this.setState({
            "image1": nm
        })
    }

    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }
    render() {
        var lang = constants.Language;
        console.log(lang)
        return (
            <div>
                <PageTitle title="NM Birthday Module" bread="NM Birthday / Add Pledge" />
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h5>Add Image <small> New Pledge</small></h5>
                                    <div className="ibox-tools">
                                        <a className="collapse-link">
                                            <i className="fa fa-chevron-up"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-sm-6 b-r">

                                            <div className="form-group"><label>NM Birthday Image</label> <input onChange={(file) => { this.readURL(file.target) }} ref={(image) => { this.image = image }} type="file" placeholder="Select Image" className="form-control" /></div>
                                            <div className="form-group"><label>Select Type</label>
                                                <select ref={(category) => { this.category = category }} className={"category_select form-control"} >
                                                    <option value="">--Type--</option>
                                                    {constants.type.map((category) => {
                                                        return (<option value={category}>{category}</option>)
                                                    })}
                                                </select>
                                            </div>
                                            <div className="form-group"><label>Select Language</label>
                                                <select id="lang" ref={(language) => { this.language = language }} className={"language_select form-control"} >
                                                    {Object.keys(lang).map(function (key, index) {
                                                        return <option value={key}>{lang[key]}</option>

                                                    })}

                                                </select>

                                            </div>
                                            <div className="form-group"><label>Title</label> <input ref={(title) => { this.title = title }} id="youtubeVideoTitle" type="test" placeholder="Title" className="form-control" /></div>
                                            <div className="form-group"><label>Description</label> <textarea ref={(description) => { this.description = description }} placeholder="Description" className="form-control" ></textarea></div>
                                            <div className="form-group"><label>Color</label> <input type="text" ref={(color) => { this.color = color }} placeholder="#ffffff" className="form-control" /></div>

                                            <div>
                                                <button className="btn btn-sm btn-primary pull-right m-t-n-xs" type="submit" onClick={() => this.savePledge()}>Save</button>

                                            </div>

                                        </div>


                                        <div className="col-sm-6">

                                            {/* {this.state.frame ?
                                            <div className="col-sm-6"><p className="text-center">
                                                {this.state.frame}

                                            </p> </div> : ""} */}

                                            <Cropper
                                                style={{ height: 400, width: '100%' }}
                                                aspectRatio={16 / 16}
                                                preview=".img-preview"
                                                guides={false}
                                                src={this.state.imgsrc}
                                                ref={cropper => { this.cropper = cropper; }}
                                            />
                                            {this.state.imgsrc?
                                            <div className="box" style={{ width: '50%', float: 'right' }}>
                                      
                                                    <button className="btn btn-primary" onClick={this.cropImage} style={{ float: 'right' }}>
                                                        Crop Image
              </button>
                                            
                                                <img style={{ width: '100%' }} src={this.state.cropResult} alt="cropped image" />
                                            </div>:''}

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div >);
    }
}


// WEBPACK FOOTER //
// ./src/Components/NM_Birthday_Module_2018/AddPledge.jsx